import { css } from '@emotion/react'

export const panel = css({
  // If `keepMounted (Radix `forceMount`) is set, Radix assumes inactive panels must still be displayed, so it doesn’t
  // apply the `hidden` attribute, but _does_ still set this data attribute.
  '&[data-state=inactive]': {
    display: 'none',
  },
})
